
const endpoints = {
  getComplaintsByCompany: 'public/getComplaintsByCompany',
	getComplaintTypes: 'public/getComplaintTypes'
}

export {endpoints};